export const getDocumentUtil = () => (typeof document === "undefined" ? undefined : document);
export default getDocumentUtil;
